import { Dispatch, ReactNode, SetStateAction, useState } from "react";

import Button from "../../controls/Button";
import SelectMenu from "../../controls/SelectMenu";

interface ReasonOption {
  value: number;
  label?: string;
}

interface BulkWipItemsActionFormProps {
  actionLabel: string;
  count: number;
  onConfirm: (reason: ReasonOption) => Promise<unknown>;
  options: ReasonOption[];
  setOpen: Dispatch<
    SetStateAction<{ open: boolean; childComponent: ReactNode }>
  >;
}

export default function BulkWipItemsActionForm({
  actionLabel,
  count,
  onConfirm,
  options,
  setOpen,
}: BulkWipItemsActionFormProps) {
  const [reason, setReason] = useState<ReasonOption>({ value: -1 });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    if (reason.value < 1) {
      setError("Select a reason");
      return;
    }

    setError(null);
    setLoading(true);
    try {
      await onConfirm(reason);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3 className="text-center text-base font-medium text-brand">
        {actionLabel} {count} selected item{count === 1 ? "" : "s"}?
      </h3>
      <div className="mt-4">
        <SelectMenu
          handleInputChange={(event: { target: { value: ReasonOption } }) =>
            setReason(event.target.value)
          }
          name="reason_selected"
          options={options}
          value={reason}
          title="Reason"
          error={error}
          menuPortalTarget={document.body}
        />
      </div>
      <div className="mt-6 flex justify-center gap-3">
        <Button
          variant="secondary"
          disabled={loading}
          onClick={() => setOpen({ open: false, childComponent: null })}
        >
          Cancel
        </Button>
        <Button variant="danger" loading={loading} onClick={confirm}>
          {actionLabel} ({count})
        </Button>
      </div>
    </div>
  );
}
